<template>
  <div class="project-detail">
    <div class="book-container">
      <!-- 基础信息卡片 -->
      <div class="card info-card glass">
        <div class="info-grid">
          <div class="info-item">
            <span class="label">作者</span>
            <span class="val">{{ detail.author }}</span>
          </div>
          <div class="info-item">
            <span class="label">译者</span>
            <span class="val">{{ detail.translator || '—' }}</span>
          </div>
          <div class="info-item">
            <span class="label">出版社</span>
            <span class="val">{{ detail.publisher || '—' }}</span>
          </div>
          <div class="info-item">
            <span class="label">出版时间</span>
            <span class="val">{{ detail.publishDate || '—' }}</span>
          </div>
          <div class="info-item">
            <span class="label">读完时间</span>
            <span class="val">{{ detail.finishReadDate || '—' }}</span>
          </div>
        </div>
        <div class="btn-wrap">
          <button class="btn primary-btn" @click="handleDownload">下载本书</button>
          <button class="btn" @click="back">返回列表</button>
        </div>
      </div>

      <!-- 书籍介绍 -->
      <div class="card glass">
        <h2 class="card-title">书籍介绍</h2>
        <p class="text">{{ detail.officialIntro }}</p>
        <h3 class="sub-title">书籍亮点</h3>
        <div class="feature-grid">
          <div class="feature-item glass" v-for="feat in detail.bookHighlightArray" :key="feat">
            {{ feat }}
          </div>
        </div>
      </div>

      <!-- 手写原生Tab，替代el-tabs -->
      <div class="card glass">
        <h2 class="card-title">书籍信息</h2>
        <div class="tab-wrap">
          <div class="tab-header">
            <div
                class="tab-item"
                :class="{active: activeTab === 'xml'}"
                @click="activeTab = 'xml'"
            >
              摘抄笔记
            </div>
            <div
                class="tab-item"
                :class="{active: activeTab === 'config'}"
                @click="activeTab = 'config'"
            >
              读后感
            </div>
          </div>
          <div class="tab-content">
            <div v-show="activeTab === 'xml'" class="markdown-block">
              <div class="markdown" v-html="renderMarkdown(detail.extractContent)"></div>
            </div>
            <div v-show="activeTab === 'config'" class="markdown-block">
              <div class="markdown" v-html="renderMarkdown(detail.readNote)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import showToast from "@/utils/toast";
import request from "@/api/request";
import { marked } from 'marked'

// Markdown渲染 + HTML消毒（建议后续增加DOMPurify，这里先保留原有逻辑）
const renderMarkdown = (mdText) => {
  if (!mdText) return '<p style="color:#8892a0;">暂无内容</p>'
  return marked.parse(mdText)
}
const route = useRoute()
const router = useRouter()
const activeTab = ref('xml')

const detail = ref({})
const queryBookDetailByBookId = async () => {
  try {
    const response = await request.get(`/v1/api/book/queryBookDetailByBookId?bookId=${route.query.id}`)
    const resp = response.data
    if (resp.responseCode === '0000') {
      detail.value = resp.data
    } else {
      showToast(resp.responseDesc)
    }
  } catch (e) {
    showToast(e.message)
  }
}
onMounted(() => {
  queryBookDetailByBookId()
})

const handleDownload = () => {
  console.log('下载本书')
}

const back = () => {
  router.push('/book')
}
</script>

<style scoped>
.project-detail {
  width: 100%;
  padding: 100px 20px 40px 20px;
  box-sizing: border-box;
  background: var(--laputa-body-background);
  min-height: 100vh;
}

.book-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
}

/* Hero封面 */
.hero {
  width: 100%;
  position: relative;
  height: 360px;
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid rgba(136, 154, 176, 0.18);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(12px);
  background: rgba(255, 255, 255, 0.55);
}

.hero-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.0) 0%, rgba(255, 255, 255, 0.72) 100%);
}

.hero-text {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 40px;
  z-index: 2;
}

.hero-text h1 {
  font-size: 44px;
  margin: 0 0 8px;
  background: linear-gradient(90deg, #3c4858, #546e8c);
  -webkit-background-clip: text;
  color: transparent;
  font-weight: 600;
}

.hero-text p {
  font-size: 20px;
  margin: 0 0 12px;
  color: #334155;
  opacity: 0.95;
}

.tags {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.status-tag{
  font-size:14px;
  padding:4px 10px;
  border-radius:999px;
  background:rgba(70, 130, 220, 0.12);
  color:#2b6cb8;
}
.status-tag.finish{
  background:rgba(22, 180, 130, 0.12);
  color:#0e996e;
}

/* 卡片通用 毛玻璃，和列表页统一 */
.card {
  width: 100%;
  border-radius: 24px;
  padding: 32px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  backdrop-filter: blur(12px);
}

.card-title {
  font-size: var(--laputa-fontsize-28);
  margin: 0 0 20px;
  color: var(--laputa-common-font-color);
  border-left: 4px solid var(--laputa-common-font-color);
  padding-left: 12px;
}

.sub-title {
  font-size: var(--laputa-fontsize-16);
  margin: 24px 0 12px;
  color: var(--laputa-common-secondary-font-color);
}

.text {
  line-height: 1.75;
  font-size: var(--laputa-fontsize-16);
  color: #334155;
}

/* 信息网格 */
.info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 28px;
}

.info-item .label {
  display: block;
  margin-bottom: 4px;
  font-size: var(--laputa-fontsize-14);
  color: var(--laputa-common-thirdary-font-color);
}

.info-item .val {
  font-size: var(--laputa-fontsize-15);
  font-weight: 500;
  color: var(--laputa-common-font-color);
}

.btn-wrap {
  display: flex;
  gap: 14px;
}
.btn{
  border: none;
  border-radius:999px;
  padding: 9px 20px;
  font-size:var(--laputa-fontsize-15);
  cursor:pointer;
  transition:0.24s ease;
  background: var(--laputa-btn-background);
  color: var(--laputa-common-inverse-font-color);
}
/* 主按钮改为纯色蓝色，去掉渐变 */
.primary-btn{
  background: var(--laputa-primary);
  color:var(--laputa-white);
}
.primary-btn:hover{
  background:var(--laputa-primary);
}
.btn:hover{
  background:var(--laputa-primary);
  color:var(--laputa-white);
  border-color: transparent;
}

/* 特性网格 */
.feature-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.feature-item {
  padding: 16px;
  border-radius: 16px;
  color: var(--laputa-common-font-color);
  transition: 0.25s ease;
}

.feature-item:hover {
  border-color: var(--laputa-glass-border-color);
  box-shadow: var(--laputa-glass-shadow);
  transform: translateY(-2px);
}

/* 原生Tab组件 */
.tab-wrap{
  width:100%;
}
.tab-header{
  display:flex;
  gap:4px;
  border-bottom:1px solid rgba(136, 154, 176, 0.2);
  margin-bottom:20px;
}
.tab-item{
  padding:10px 20px;
  font-size:var(--laputa-fontsize-15);
  color:var(--laputa-common-secondary-font-color);
  cursor:pointer;
  position:relative;
  transition:0.22s;
}
.tab-item.active{
  color:var(--laputa-primary);
}
.tab-item.active::after{
  content:"";
  position:absolute;
  bottom:-1px;
  left:0;
  width:100%;
  height:2px;
  background:var(--laputa-primary);
}
.markdown-block{
  background: var(--laputa-body-background-other);
  padding: 24px;
  border-radius: 16px;
  border: 1px solid var(--laputa-glass-border);
  line-height:1.8;
}
.markdown-block :deep(h1,h2,h3,h4){
  margin-top:1.2em;
  margin-bottom:0.6em;
}
.markdown-block :deep(p){
  margin:0.8em 0;
}

/* 响应式 */
@media (max-width: 1024px) {
  .info-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .info-grid {
    grid-template-columns: 1fr;
  }

  .feature-grid {
    grid-template-columns: 1fr;
  }

  .hero {
    height: 260px;
  }

  .hero-text h1 {
    font-size: 32px;
  }

  .btn-wrap {
    flex-wrap: wrap;
  }
  .tab-header{
    gap:0;
  }
  .tab-item{
    padding:10px 14px;
    font-size:15px;
  }
}
</style>
